export default __webpack_public_path__ + "static/media/_calculator_cpa_active.dd2cc7f9.svg";